export class WidgetGeolocation {
    constructor(latitude, longitude, accuracy, positionSource, timestamp) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.accuracy = accuracy;
        this.positionSource = positionSource;
        this.timestamp = timestamp;
    }
}
